import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { withSpinner } from "../../extensions/withSpinner.extension"; 
import { API_ROOT } from "../../types/constants/appconstants";
import { NotificationRecordable } from "../../types/notificationrecordable";

@Injectable({ 
    "providedIn": "root"
})

export class NotificationRecordableService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private notificationRecordablesBaseUrl = this.apiRoot + "api/recordableNotifications";

    getNotificationRecordable(edhMarketId: number): Observable<NotificationRecordable> {
        return withSpinner(this.http).get<NotificationRecordable>(`${this.notificationRecordablesBaseUrl}/${edhMarketId}`);
    }

    saveNotificationRecordable(notificationRecordable: NotificationRecordable): Observable<NotificationRecordable> {
        return withSpinner(this.http).post<NotificationRecordable>(`${this.notificationRecordablesBaseUrl}`, {notificationRecordable});
    }

    deleteNotificationRecordable(notificationId: number): Observable<number> {
        return withSpinner(this.http).delete<number>(`${this.notificationRecordablesBaseUrl}/${notificationId}`);
    }
}